export default __webpack_public_path__ + "static/media/error.950cfcc9.svg";